export function PageNodesToBoxList(pageNodeList) {
  var boxList = [];
  var n = pageNodeList.length;
  for (var i = 0; i < n; i++) {
    var box = pageNodeList[i].GetChartBox();
    boxList.push(box);
  }

  return boxList;
}
